// components/Common/TitleChips.jsx
// 대표 + 서브 칭호를 함께 표시하는 공통 컴포넌트
// 사용 예: <TitleChips main="펨섭" sub="리틀" />

import React from 'react';
import { Chip, Stack } from '@mui/material';

const TitleChips = ({ main, sub }) => {
    return (
        <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
            {/* 서브 칭호 (보라색 계열) */}
            {sub && (
                <Chip
                    label={sub}
                    variant="outlined"
                    sx={{
                        fontWeight: 600,
                        fontSize: 14,
                        color: '#7e57c2',
                        borderColor: '#b39ddb',
                        backgroundColor: 'transparent',
                    }}
                />
            )}
            {/* 대표 칭호 (파란색) */}
            {main && (
                <Chip
                    label={main}
                    color="primary"
                    variant="outlined"
                    sx={{
                        fontWeight: 600,
                        fontSize: 14,
                    }}
                />
            )}
        </Stack>
    );
};

export default TitleChips;
